module.exports = __webpack_public_path__ + "img/europass-cv.def77d9c.png";